import MuiListItemAvatar from '@material-ui/core/ListItemAvatar';

export default MuiListItemAvatar;
